// 语言包，中文, 字段要按照字母进行排序
export default {
    age: "年龄",

    cancelData: "取消",
    changeLanguage: "修改语言",
    changePassword: "修改密码",
    changeRole: "切换角色",
    closeAllTabs: "关闭全部标签",
    closeLeftTabs: "关闭左侧标签",
    closeOtherTabs: "关闭其它标签",
    closeRightTabs: "关闭右侧标签",
    columnName: "字段名称",
    confirmData: "确定",
    customerDetail: "客户详情",
    customerList: "客户列表",
    customerManage: "客户管理",
    customerMobile: "手机号",
    customerName: "客户名称",

    display: "显示",
    displayNot: "不显示",
    displayOrNot: "是否显示",

    gender: "性别",

    helps: "帮助文档",
    home: "首页",

    indexName: "序号",

    logout: "退出登录",
    languageName: "选择语言",

    muchMoreTabs: "您已经打开了太多的菜单，先关掉几个吧",

    notice: "提示",

    operation: "操作",
    orderAmount: "订单金额",
    orderDate: "订单日期",
    orderDetail: "订单详情",
    orderList: "订单列表",
    orderManage: "订单管理",
    orderStatus: "订单状态",

    payee: "收款人",

    refreshPage: "刷新页面",
    rename: "自定义名称",
    requiredUserName: "用户名称不能为空",
    returnHome: "返回官网",
    reviewer: "审核人",

    saveChange: "记住我的选择",
    setColumnName: "设置列表字段",
    stockName: "仓库名称",

    toDetail: "详情",

    userName: "用户名称",
    userInfo: "个人信息",

    viewVersion: "查看版本",
    toAddNew: "新建",
    toEdit: "编辑",
    toDelete: "删除",
    deleteCustomColumn: '删除自定义字段，删除后不可恢复，是否继续？',
    nextLevel: "下级数据",
    prefLevel: "上级数据",
    data: "数据",
    moreInfo: "更多信息",
    lessInfo: "点击收起",
    clearSession: "清除缓存",
}